/* istanbul ignore file */
import React from 'react';
import { Box } from '@mui/material';

const STATUS_COLORS = {
  IN_PROGRESS: 'info.main',
  IN_PROGRESS_WITH_DELAY: 'error.main',
  COMPLETED: 'success.main',
  COMPLETED_WITH_DELAY: 'warning.main',
} as const;

const LARGE_INDICATOR_STATUSES = new Set(['COMPLETED', 'COMPLETED_WITH_DELAY', 'IN_PROGRESS_WITH_DELAY']);

const ProgressIndicator = ({
  status,
  color,
  icon,
  isLarge,
}: {
  status: string;
  color?: string;
  icon: React.ReactNode;
  isLarge?: boolean;
}) => {
  const normalizedStatus = status.toUpperCase();
  const statusColor = color || STATUS_COLORS[normalizedStatus as keyof typeof STATUS_COLORS] || 'text.secondary';
  const hasLargeIndicator = isLarge ?? LARGE_INDICATOR_STATUSES.has(normalizedStatus);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        '&::after': {
          content: '""',
          borderRadius: '1px',
          backgroundColor: statusColor,
          height: '4px',
          flex: '1 1 auto',
          marginLeft: '4px',
        },
      }}
    >
      <Box
        sx={{
          width: hasLargeIndicator ? '18px' : '12px',
          height: hasLargeIndicator ? '18px' : '12px',
          marginTop: hasLargeIndicator ? '-3px' : 0,
          marginBottom: hasLargeIndicator ? '-3px' : 0,
          backgroundColor: statusColor,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2px',
          '& svg': {
            color: 'common.white',
            width: '100%',
            height: '100%',
          },
        }}
      >
        {icon}
      </Box>
    </Box>
  );
};

export default ProgressIndicator;
